module.exports = __webpack_public_path__ + "static/media/SyrianBuilding.a21c6100.png";